import { StudentNotification } from 'shared/types/notificationTypes'
import styles from "./styles.module.css"
import Pane from 'components/Dashboards/General/Pane'
import { Button } from 'react-bootstrap'
import { updateStudentNotificationStatus } from "shared/routes/notifications/studentNotifications"
import ToolTip from 'components/General/ToolTip'
import useBoolean from 'helpers/useBoolean'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import { SubmissionStudentState } from 'pages/Dashboard/Student/Grades/Submission/SubmissionStudent'
import studentRoute from "shared/routes/student"
import { BeatLoader } from 'react-spinners'
import { useCallback } from "react"

interface Props {
  notification: StudentNotification
  updateCallback: (notificationId: string) => void
}

const StudentNotificationItem = ({ notification, updateCallback } : Props) => {

  const navigate = useNavigate()
  const [openingNotification, toggleOpeningNotification] = useBoolean(false)

  const markAsRead = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    await updateStudentNotificationStatus(notification.id, "read")
    updateCallback(notification.id)
  }

  const markAsUnread = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    await updateStudentNotificationStatus(notification.id, "unread")
    updateCallback(notification.id)
  }

  const openNotification = useCallback(async (notification: StudentNotification) => {
      const validNotificationTypes = ["submission-graded", "submission-rework", "submission-reject"] //there might be more types in the future
      if (!validNotificationTypes.includes(notification.type)) {
        return
      }
  
      toggleOpeningNotification()
      await updateStudentNotificationStatus(notification.id, "read") // mark as read after click open notification
  
      const assignment = await studentRoute.getAssignment(notification.assignment.id)
      if (notification.assignment && !assignment) {
        toast.error("There was an error opening the notification.")
        return
      }
  
      toggleOpeningNotification()
  
      const submissionIndex = assignment.submissions.findIndex((submission) => submission.id === notification.submissionId)
      navigate("/dashboard/student/grades/submission", {
        state: {
            currentIndex: submissionIndex,
            assignment: assignment,
            submission: assignment.submissions[submissionIndex],
            studentId: notification.studentId,
            userType: "Student",
            previousPage: "/dashboard/student/notifications",
        } as SubmissionStudentState
      })
  }, [toggleOpeningNotification, navigate])

  const read = notification.status === "read"

  if (openingNotification) <BeatLoader />

  return (
    <div onClick={() => openNotification(notification)}>
      <Pane 
        key={notification.id}
        className={`${styles.fontSize} rounded border border-1 ${read ? `border-info` : `border-dark`} py-2 m-1 d-flex flex-column align-items-start justify-content-start flex-lg-row align-items-lg-center justify-content-lg-between ${styles.notification} ${notification.status === "read" && `bg-light`}`}>
          <div className="text-start">
            <p>
              Your submission for 
              <span className="mx-1 fw-bold mark">{notification.assignment.title}</span>
              has been 
              {notification.type === "submission-graded" ? <span> graded. <i className={`fas fa-check text-success`}/></span> : 
              notification.type === "submission-reject" ? <span> rejected. <i className={`fas fa-x text-danger`}/></span> : 
              notification.type === "submission-rework" ? <span> requested to be reworked. <i className={`fas fa-repeat text-info`}/></span> : ""}
            </p>
            <p className={`mb-2 ${notification.status === "read" ? "text-dark" : "text-muted"}`}>{notification.created}</p>
          </div>
          <div>
            {!read && <ToolTip title="Mark as read"><Button variant="outline-primary" onClick={markAsRead}><i className={`fas fa-envelope fs-5`}/></Button></ToolTip>}
            {read && <ToolTip title="Mark as unread"><Button variant="outline-success" onClick={markAsUnread}><i className={`fas fa-envelope-circle-check fs-5`}/></Button></ToolTip>}
          </div>
      </Pane>
    </div>
  )
}

export default StudentNotificationItem
